export var MuiCard = {
    styleOverrides: {
        root: {
            backgroundImage: 'none',
        },
    },
};
